import type { IconSvgObject } from './types';

const MoveDownIcon: IconSvgObject = [
  ["path", { d: "M12.7422 4C12.7422 3.58579 12.4064 3.25 11.9922 3.25C11.578 3.25 11.2422 3.58579 11.2422 4H11.9922H12.7422ZM11.2422 19.5C11.2422 19.9142 11.578 20.25 11.9922 20.25C12.4064 20.25 12.7422 19.9142 12.7422 19.5H11.9922H11.2422ZM11.9922 4H11.2422V19.5H11.9922H12.7422V4H11.9922Z", fill: "currentColor", key: "0" }],
  ["path", { d: "M6.99219 15C7.97523 16.0114 10.5918 20 11.9922 20C13.3926 20 16.0091 16.0114 16.9922 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MoveDownIcon;
